export const compileAnimation = (
    animation?: NormalizedAnimationProp
): string => {
    return ''
}

export type UnnormalizedAnimationProp = NormalizedAnimationProp

export type NormalizedAnimationProp = {
    keyframes?: string,
    name?: string,
    duration: string
}
